type ClassNamesInput<ClassNames, Info> = ((info: Info) => ClassNames) | ClassNames | undefined;

const isClassNamesFunction = <ClassNames, Info>(
  classNames: ClassNamesInput<ClassNames, Info>,
): classNames is (info: Info) => ClassNames => typeof classNames === 'function';

export const resolveClassNames = <ClassNames, Info>(
  classNames: ClassNamesInput<ClassNames, Info>,
  merge: (resolvedClassNames?: ClassNames) => ClassNames,
): ((info: Info) => ClassNames) | ClassNames => {
  if (isClassNamesFunction(classNames)) {
    return (info) => merge(classNames(info));
  }

  return merge(classNames);
};
